// --------------------------------------- Project List
export const ProjectList = [
  {
    img: "/1.jpg",
    title: "Mitsubishi Sales Force ID",
    description:
      "Mitsubishi sales force application in Indonesia.",
    tech_stack: ["Flutter", "Firebase", "Clean Architecture", "OCR"],
    playstore_url: "https://play.google.com/store/apps/details?id=id.com.mmksi.salesforce&hl=en_US",
    appstore_url: "https://apps.apple.com/id/app/mitsubishi-sales-force-id/id1483823371",
    web_url: "",
  },
  {
    img: "/2.jpg",
    title: "Mitsubishi Service Ops ID",
    description:
      "Application to facilitate operational work services at Mitsubishi Indonesia Dealers.",
    tech_stack: ["Flutter", "Firebase", "Clean Architecture", "Websocket"],
    playstore_url: "https://play.google.com/store/apps/details?id=id.com.mmksi.serviceoperation&hl=en_US",
    appstore_url: "",
    web_url: "",
  },
  {
    img: "/4.jpg",
    title: "Hewania: Dokter Hewan Online",
    description:
      "Hewania is here as a super-platform to make it easier for you to find solutions in caring for your beloved pets.",
    tech_stack: ["Flutter", "Firebase", "Agora", "Websocket"],
    playstore_url: "https://play.google.com/store/apps/details?id=com.hewania.app&hl=id",
    appstore_url: "https://apps.apple.com/id/app/hewania-dokter-hewan-online/id1616692928?l=id",
    web_url: "",
  },
  {
    img: "/5.jpg",
    title: "Hewania Vet",
    description:
      "Hewania Vet is an app for veterinarians who want to help care for your pets.",
    tech_stack: ["Flutter", "Firebase", "Agora", "Websocket"],
    playstore_url: "https://play.google.com/store/apps/details?id=com.doctorapp.hewania&hl=id",
    appstore_url: "https://apps.apple.com/id/app/hewania-vet/id1618979481?l=id",
    web_url: "",
  },
  {
    img: "/3.jpg",
    title: "Persona",
    description:
      "Employee attendance application from Mitsubishi in Indonesia.",
    tech_stack: ["Flutter", "Firebase", "Clean Architecture", "Geocoding"],
    playstore_url: "https://play.google.com/store/apps/details?id=com.bsi.employeeapp&hl=en",
    appstore_url: "",
    web_url: "",
  },
  {
    img: "/6.jpg",
    title: "Baqat",
    description:
      "Platforms for sharing videos like YouTube exclusively for competitions.",
    tech_stack: ["Flutter", "Firebase", "Social Login"],
    playstore_url: "",
    appstore_url: "",
    web_url: "",
  },
  {
    img: "/7.jpg",
    title: "TEH OPLOS kAsegaran",
    description:
      "Company Profile Website.",
    tech_stack: ["Flutter", "PWA"],
    playstore_url: "",
    appstore_url: "",
    web_url: "https://tehoploskasegaran.com/",
  },
  {
    img: "/8.jpg",
    title: "TEH OPLOS kAsegaran Dashboard",
    description:
      "Internal application used to manage store branches, raw materials, package sales, and inventory.",
    tech_stack: ["Flutter", "PWA"],
    playstore_url: "",
    appstore_url: "",
    web_url: "",
  },
  {
    img: "/9.jpg",
    title: "SIPMESIN",
    description:
      "Application used to manage and display products from Kementerian Perindustrian.",
    tech_stack: ["Flutter", "PWA"],
    playstore_url: "",
    appstore_url: "",
    web_url: "https://sipmesin-ikm.id/",
  },
  {
    img: "/10.jpg",
    title: "Warespaze",
    description:
      "Web application on-demand warehouse marketplace that connects the supply and demand of warehouse spaces.",
    tech_stack: ["ReactJs"],
    playstore_url: "",
    appstore_url: "",
    web_url: "https://warespaze.com/",
  },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: "/dart.svg",
    name: "Dart",
  },
  {
    img: "/flutter.svg",
    name: "Flutter",
  },
  {
    img: "/firebase.svg",
    name: "Firebase",
  },
  {
    img: "/shorebird.png",
    name: "Shorebird",
  },
  {
    img: "/websocket.svg",
    name: "WebSocket",
  },
  {
    img: "/git.svg",
    name: "Git",
  },
  {
    img: "/reactjs.svg",
    name: "ReactJS",
  },
  {
    img: "/pwa.svg",
    name: "PWA",
  },
  {
    img: "/figma.svg",
    name: "Figma",
  },
  {
    img: "/agora.png",
    name: "Agora",
  },

  {
    img: "/maps.svg",
    name: "Maps",
  },
  {
    img: "/vscode.svg",
    name: "VS Code",
  },
  {
    img: "/android-studio.svg",
    name: "Android",
  },
  {
    img: "/xcode.svg",
    name: "Xcode",
  },
  {
    img: "/reactjs.svg",
    name: "ReactJS",
  },
];
